export default function(){
    $(window).scroll(function(){
        let offset = $('body').hasClass('has-callout') ? 80 : 24;
        if ($(this).scrollTop() > offset ) {
            $('.banner__wrap').addClass('is-sticky');
            $('.header__mobile-nav').addClass('is-sticky');
        } else {
            $('.banner__wrap').removeClass('is-sticky');
            $('.header__mobile-nav').removeClass('is-sticky');
        }
    });
}